import axios from 'axios'
import Cookies from "js-cookie";


export const httpAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    Authorization: Cookies.get("Dealer-User-Token")
  } 
});

class WatermarkUtil {
  static _refreshTimerId = null;
  static REFRESH_INTERVAL = 30 * 60 * 1000;

  static async initWatermark() {
    if (!window.watermark) {
      console.warn('水印JS SDK未加载成功');
      return false;
    }
    const watermarkData = await this.getWatermarkData();
    if (!watermarkData) return false;

    if (window.watermark.isExist()) {
      window.watermark.destroyWm();
    }

    window.watermark.init({
      data: watermarkData,
      mContentList: ['两网智蛛经销商平台', new Date().toLocaleDateString()],
      conflictDetectionTime: 60 * 30
    });

    this.startRefreshTimer();
    return true;
  }

  static async getWatermarkData() {
    const token = Cookies.get("Dealer-User-Token");
    if (!token) {
      console.warn('用户未登录或用户信息不完整');
      return null;
    }

    try {
      const response = await httpAxios({
        url: '/v2/appUserService/getWebWaterMarkInfo',
        method: 'post',
        data: {
          lastToken: token
        }
      });
      if (response.status === 200 && response.data && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error('水印数据获取失败:', error);
      return null;
    }
  }

  static destroyWatermark() {
    this.stopRefreshTimer();
    if (window.watermark && window.watermark.isExist()) {
      window.watermark.destroyWm();
    }
  }

  static async refreshWatermark() {
    this.destroyWatermark();
    return await this.initWatermark();
  }

  static startRefreshTimer() {
    this.stopRefreshTimer();
    this._refreshTimerId = setInterval(() => {
      this.refreshWatermark();
    }, this.REFRESH_INTERVAL);
    console.log(`[WatermarkUtil] 水印定时刷新已开启，间隔：${this.REFRESH_INTERVAL / 1000 / 60} 分钟`);
  }

  static stopRefreshTimer() {
    if (this._refreshTimerId) {
      clearInterval(this._refreshTimerId);
      this._refreshTimerId = null;
      console.log('[WatermarkUtil] 水印定时刷新已停止');
    }
  }
}

export default WatermarkUtil;
